<div class="terms-component">
  <p-card>
    <div class="terms-container">
      <img class="background-image" src="assets/odot-heb.svg" alt="">
      <div class="section">
        <h2 class="title">תנאי שימוש באתר האינטרנט, במידע ובתוכן המופק על ידי רשות העתיקות</h2>
        <p>
          ברוכים הבאים לאתר האינטרנט של- "רשות העתיקות" (להלן: "הרשות" ו/או "המפעיל"), הפועל בכתובת www.iaa.org.il ובכל כתובת נוספת בהתאם לשיקול דעתה של הרשות (להלן: "האתר"). באתר מוצג תוכן המפורסם על ידי רשות העתיקות, מפרסמי תוכן, ושירותים נוספים אחרים (להלן: "השירות").
        </p>
      </div>

      <div class="section">
        <p>
          יש לקרוא בעיון את תנאי השימוש באתר. השימוש באתר הינו בכפוף לתנאי השימוש המפורטים להלן ("תנאי השימוש") ולמדיניות הפרטיות (להלן: "מדיניות הפרטיות") ולכל מסמך אחר שיפורסם על ידי רשות העתיקות. עם שימושכם באתר ובתוכן הכלול בו אתם מאשרים ומסכימים בזאת לתנאי השימוש הנ"ל ולמדיניות הפרטיות.
        </p>
      </div>

      <div class="section">
        <p>
          שימושכם באתר מהווה אישור לכך שקראתם את תנאי השימוש ואת מסמך מדיניות הפרטיות, הבנתם את תוכנם והסכמתם להיות כפופים לתנאיהם, וכי לא תהא לכם ו/או למי מטעמכם כל טענה ו/או דרישה ו/או תביעה כנגד האתר ו/או הרשות ו/או עובדיה, בכל הקשור להוראות ולתנאים של האתר. הרשות שומרת לעצמה את הזכות לעדכן את תנאי השימוש מעת לעת, לפי שיקול דעתה הבלעדי וללא צורך בהודעה מראש. תוקפו של שינוי בתנאי השימוש יחל מרגע פרסומו באתר בגרסה העדכנית ביותר בכל זמן נתון.
        </p>
      </div>

      <div class="section">
        <p>
          אם אינכם מסכימים לתנאי השימוש או לחלקים מהם, אינכם רשאים להשתמש בשירות האתר ובתכניו.
        </p>
      </div>

      <div class="section">
        <p>
          התנאים מנוסחים בלשון זכר מטעמי נוחות בלבד, אולם הם מיועדים לגברים ולנשים כאחד. ככל שלשון התנאים מנוסחת ביחיד הדברים יהיו נכונים גם לרבים, וההפך.
        </p>
      </div>
      <div class="section">
        <ol class="terms-list">
          <li class="term-item">
            <h3>תנאים כלליים</h3>
            <p>
              מטרת תנאי השימוש הינה להסדיר את היחסים בין הרשות, מפעילת האתר, לבין כל אדם ו/או גוף ו/או גורם או מי מטעמם של אלה אשר עושים שימוש באתר ("המשתמשים", "הנכם" או "אתם"). יובהר, כי תנאי השימוש חלים על השימוש באתר ובתכנים הכלולים בו באמצעות כל מכשיר מחשב PC ו/או טלפון סלולרי ו/או מכשיר תקשורת אחר (כדוגמת טאבלטים, מחשבי כף יד למיניהם וכיו"ב) (להלן:"מכשיר חכם").
            </p>
          </li>

          <li class="term-item">
            <h3>הגדרות</h3>
            <ul>
              <li><strong>המפעיל:</strong> יוגדר להלן כמפעיל ובעלי האתר ובעלת הזכויות על האתר והתכנים בו, על מרכיביו ועל הרעיון שבבסיסו, היא רשות העתיקות לרבות עובדיה, נציגיה וכל המועסק מטעמה.</li>
              <li><strong>האתר:</strong> אתר האינטרנט המופעל על ידי המפעיל בכתובת www.iaa.org.il או בכל כתובת אחרת בהתאם לשיקול דעתו של המפעיל.</li>
              <li><strong>משתמשי האתר:</strong> יוגדרו להלן ככל מי שבחר להשתמש באתר, לרבות כל מקום שהובא משתמש ביחיד ו/או ברבים.</li>
              <li><strong>תוכן:</strong> כל תוכן המפורסם באמצעות האתר. תכנים מסוג כתבות, ידיעות, מאמרים, נתונים, רכיבי מידע ארכיוני, תמונות, מפות, איורים, סרטוני וידאו, קטעי אודיו, הודעות לציבור, מודעות פרסומיות, חדשות פנימיות, מכרזים, טפסים ועוד.</li>
              <li><strong>מפרסם תוכן:</strong> כל מי שמפרסם תוכן באמצעות האתר.</li>
              <li><strong>זכויות יוצרים:</strong> כמשמעותם בחוק זכות יוצרים, תשס"ח-2007.</li>
            </ul>
          </li>

          <li class="term-item">
            <h3>מדיניות ההנגשה של הרשות</h3>
            <p>
              הרשות מאפשרת נגישות דיגיטלית חופשית למאגרי המידע המקצועי והמדעי שלה ולכתבי העת שבהוצאתה, זאת במסגרת פעילותה לשימור, טיפוח והעמדת מאגרי המידע וכתבי העת לשימוש הציבור הרחב. הרשות פועלת לזיהוי ואיתור יוצרים ובעלי זכויות יוצרים, חלק מן המידע המוצג במאגרים וכתבי העת מצוי תחת זכויות היוצרים של רשות העתיקות, חלק מהמידע מונגש לאחר קבלת רשות מבעלי הזכויות, חלקו האחר מונגש על ידי הרשות במסגרת זכותה לבצע שימוש הוגן בחומרים בהתאם לחוק זכות יוצרים.
            </p>
          </li>

          <li class="term-item">
            <h3>נהלי הרשמה ומסירת מידע אישי</h3>
            <p>
              קבלת חלק מהשירות באתר מחייבת הרשמה מראש ויצירת חשבון בהתאם להוראות הרישום. מי שנרשם לשירות של האתר ייקרא "משתמש". למשתמשים ישנה זכות אישית ומוגבלת, לא בלעדית ולא עבירה ושאי אפשר לתת בה רישיונות משנה, והיא מוגבלת אך ורק למטרות המפורטות בתנאי שימוש אלה.
            </p>
            <p>
              הגישה לחלק מהתוכן של האתר, המחייב הרשמה אישית, הינה מאובטחת וניתנת לביצוע באמצעות הכנסת פרטים מזהים, מספר טלפון וסיסמא, דואר אלקטרוני ו/או כל פרט מזהה נוסף, כאשר הרישום לאתר נערך לפי אימות מספר טלפון.
            </p>
          </li>

          <li class="term-item">
            <h3>פרסום באתר ואחריות לפרסומים באתר</h3>
            <p>
              המפעיל או גורמים עצמאיים שיורשו לפעול מטעמו, יוכלו להציע למפרסמי תוכן ולנותני שירות ולגורמים שלישיים אחרים, אפשרות לפרסם תכנים ו/או מודעות ו/או קידום באתר, תמורת תשלום כפי שיקבע המפעיל מעת לעת.
            </p>
          </li>

          <li class="term-item">
            <h3>פרטיות</h3>
            <p>
              על מנת שהמפעיל יוכל לספק את המידע והשירותים, לשפרם, לבצע התחשבנות, להתאים לכם מוצרים ושירותים וכן לפנות אליכם בהצעות המותאמים לך במגוון הערוצים, המפעיל יהיה רשאי לשתף מידע שנצבר וייצבר לגביכם, תוך כדי הרישום והשימוש באתר.
            </p>
          </li>

          <li class="term-item">
            <h3>גישה לאחסון, למצלמה, וקבצי מטמון</h3>
            <p>
              באתר נעשה שימוש במצלמה לצורך צילום אם המשתמשים ירצו בכך, על כן דרושה לאתר גישה לאחסון הפנימי של המכשיר לצורך אחסון נתוני המשתמש (להלן: "קבצי מטמון") בכדי שהמשתמשים יוכלו לראות את היסטוריית הפעולות שלהם.
            </p>
          </li>

          <li class="term-item">
            <h3>שימוש בנתוני מיקום GPS</h3>
            <p>
              באתר עלול להיעשות שימוש בגלאי מיקום GPS (להלן: "מיקום") ושמירת נתוני מיקום בקבצי מטמון ובציוד הקצה של המפעיל בכדי ששרתי האתר יוכלו לזהות את המשתמשים הרשומים ועל מנת לאפשר תפעול תקין לאתר.
            </p>
          </li>

          <li class="term-item">
            <h3>אבטחת מידע והגנה על פרטיות משתמשי האתר</h3>
            <p>
              המפעיל דואג לאבטחת המידע המצוי באתר באמצעות חברת האחסון בה מאוחסן האתר ובאמצעים נוספים. עם זאת, כבכל מאגר מידע ממוחשב, המפעיל אינו יכול להבטיח חסינות מוחלטת מפני חדירות למחשביו.
            </p>
          </li>

          <li class="term-item">
            <h3>דיוור ישיר ומשלוח הודעות טקסט למשתמשי האתר</h3>
            <p>
              בעצם הרשמתכם כמשתמשים רשומים, אתם מביעים את הסכמתכם ומרשים למפעילי האתר לשלוח למכשיר המחשב לכם (PC) ו/או המכשיר החכם שלכם ו/או לכתובת הדואר האלקטרוני שאותה ציינתם ו/או אשר איתה נרשמתם, מסרים והצעות פרסומיות.
            </p>
          </li>
          <li class="term-item">
            <h3>זכויות יוצרים וקניין הרוחני</h3>
            <p>
              המפעיל הינו בעל זכויות היוצרים ובעל הזכות בקניין הרוחני באופן בלעדי באתר. התוכן באתר מוגן בזכויות יוצרים ובזכויות קניין רוחני אחרות, של הרשות או של צדדים שלישיים, בהתאם לחוקי מדינת ישראל, אמנות בינלאומיות, חוקי זכויות יוצרים של מדינות אחרות והסכמים בין הרשות וצדדים שלישיים אחרים.
            </p>
            <p>
              בהתאם לדיני זכויות היוצרים, אסור להעתיק, לשכפל, לשנות, להפיץ, לשדר, להציג בציבור או במקום ציבורי או בפני קהל, לבצע, לפרסם, להעניק רישיונות עבור צד ג', ליצור עבודות הנגזרות מתוך הפרסום, או להעביר הלאה, באופן זמני או קבוע כל תוכן מהאתר.
            </p>
          </li>

          <li class="term-item">
            <h3>הגבלת אחריות המפעיל ו/או מי מטעמו</h3>
            <p>
              שירותי האתר ניתנים לשימוש כמות שהם (AS IS) לא תהא לכם כל טענה, תביעה או דרישה כלפי המפעיל ו/או מי מטעמו בגין תכונות השירות, יכולותיו, מגבלותיו או התאמתו לצרכיכם ודרישותיכם.
            </p>
            <p>
              המפעיל אינו מתחייב שהשירות באתר לא יופרע, יינתן כסדרו או בלא הפסקות, יתקיים בבטחה וללא טעויות, ויהיה חסין מפני גישה בלתי מורשית למחשבי המפעיל.
            </p>
          </li>

          <li class="term-item">
            <h3>קישורים לאתרים אחרים</h3>
            <p>
              ייתכן שמשתמש באתר יוכל לגשת לתכנים ולשירותים של צדדים שלישיים שאינם כלולים באתר זה. תכנים ושירותים אלה, המסופקים ישירות על-ידי צדדים שלישיים, אינם באחריות הרשות, גם אם הרשות סיפקה אליהם קישוריות (hyperlinks).
            </p>
          </li>

          <li class="term-item">
            <h3>שינויים באתר ו/או הפסקת השירות</h3>
            <p>
              המפעיל שומר לעצמו את הזכות הבלעדית להסיר את האתר כולו ו/או להגביל את אפשרות השימוש בו ו/או להוסיף ו/או להסיר ו/או לשנות מעת לעת את מבנה האתר, המראה שלו, ההצעות ו/או התעריפים המופיעים בה.
            </p>
          </li>

          <li class="term-item">
            <h3>שימוש אסור וחסימת משתמש</h3>
            <p>
              המפעיל רשאי להפסיק בכל עת ולאלתר, מכל סיבה שהיא, לפי שיקול דעתו המוחלט והבלעדי, את שימושו של משתמש באתר, לרבות השעיית ו/או מחיקת ו/או ביטול חשבונו.
            </p>
          </li>

          <li class="term-item">
            <h3>הגבלת שימוש פרטי ואישי בלבד</h3>
            <p>
              השימוש בשירותים, בתכנים ובמידע הכלולים באתר מותר למטרה אישית ופרטית בלבד. אין לעשות כל שימוש מסחרי באתר או בנתונים המפורסמים בו.
            </p>
          </li>

          <li class="term-item">
            <h3>כללי</h3>
            <p>
              בכל מקרה של סתירה ו/או אי התאמה בין מסמך זה לבין כל פרסום אחר, בכתב או בעל פה מכל סוג ומין, תגברנה הוראות מסמך זה והן אשר תקבענה.
            </p>
          </li>

          <li class="term-item">
            <h3>ברירת דין וסמכות שיפוט</h3>
            <p>
              בכל הנוגע לשימוש באתר ולתנאי השימוש יחולו דיני מדינת ישראל והם בלבד. מובהר ומוסכם, כי לבתי המשפט במחוז ירושלים סמכות השיפוט הבלעדית בכל הנוגע לשימוש, ופרסום באתר ובכפוף לאמור בתנאי שימוש אלה.
            </p>
          </li>

          <li class="term-item">
            <h3>פרטי המפעיל</h3>
            <p>כל הודעה למפעיל בקשר עם תנאי השימוש תעשה אליו בהודעה כתובה הכוללת פרטי הפונה, שלהלן:</p>
            <ul>
              <li>
                {{"באם אתה סבור כי פורסם באתר תוכן הפוגע בך מטעם כלשהו ו/או אם נתקלת בבעיה כלשהי עם התכנים המוצעים באתר ו/או בנוגע לשירות, אנא פנה אלינו בהתאם לפרטים שלהלן ואנו נשתדל לטפל בפנייתך בהקדם. פניות כאמור ניתן להעביר לכתובת הבאה: מנהל סביבת אינטרנט odedra@israntique.org.il"}}
              </li>
              <li>
                {{"אם ברצונך לעשות שימוש שאינו שימוש מותר על פי תקנון זה, בחומר כלשהו המפורסם באתר, הינך מוזמן לפנות אל מנהל סביבת האינטרנט ברשות העתיקות בכתובת odedra@israntique.org.il"}}
              </li>
              <li>
                {{"לנושאים הנוגעים לזכויות היוצרים ניתן לפנות אל האחראי על חופש המידע ברשות העתיקות בכתובת yoav@israntique.org.il"}}
              </li>
            </ul>
          </li>
        </ol>
      </div>

      <div class="section">
        <p>אנו מאחלים לכם גלישה נעימה.</p>
      </div>
    </div>
  </p-card>
</div>
